import axios from "axios";
import { IGcpAppDispatch } from "../../redux/store";

import config from "../../config";
import { ensureUserLoggedIn } from "../../redux/modules/auth/asyncActions";

export const fetchUserIdentity =
  () =>
  async (dispatch: IGcpAppDispatch): Promise<[string, string]> => {
    const [_, token] = await dispatch(ensureUserLoggedIn());

    const rawResponse = await axios.post(
      config.intercom.userIdentityEndpointUrl,
      { workspace_id: "GCP_APP" },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const identityParamsResponse = rawResponse.data;
    const appId = identityParamsResponse?.data?.app_id;
    const userHash = identityParamsResponse?.data?.user_hash;
    if (!appId || !userHash) {
      throw new Error("You have no access to intercom in-app messenger");
    }

    return [appId, userHash];
  };
